export default __webpack_public_path__ + "static/media/notFound.25ba533b.gif";